<template>
  <div class="search">
    <input
      v-model="searchQuery"
      :placeholder="placeholder"
      :aria-label="placeholder"
      type="text"
      @change="update"
      @keyup.enter="search"
    />
    <img
      src="~/assets/icons/search.svg"
      alt="Search Icon"
      @click="search"
    />
  </div>
</template>

<script setup lang="ts">
  defineProps({
    placeholder: {
      type: String,
      required: false,
      default: 'Search'
    }
  })

  const searchQuery = ref<string>('')
  const emit = defineEmits(['search', 'update'])

  const update = () => {
    emit('update', searchQuery.value)
  }

  const search = () => {
    emit('search', searchQuery.value)
  }
</script>

<style lang="scss" scoped>
  @import '~/assets/styles/common.scss';

  .search {
    border: 1px solid $form-field-border;
    border-radius: 4px;
    max-width: 328px;
    width: calc(100% - 24px);
    position: relative;

    @include tablet-up {
      border-width: 0 0 1px 0;
      width: 100%;
    }

    img {
      cursor: pointer;
      padding: rem(12);
      position: absolute;
      right: 4px;
      top: 0;
    }

    input {
      background-color: $white;
      border: none;
      border-radius: 4px;
      color: $ui-dark-blue;
      cursor: pointer;
      font-size: rem(16);
      max-width: 304px;
      padding: rem(12);
      width: calc(100% - 24px);
    }
  }
</style>
